export enum SectionName {
  Academy = 'academy',
  ClinicalTrials = 'projects',
  DigitalTutor = 'digital-tutor',
  DiGyn = 'patients',
  SecondOpinions = 'second-opinions',
}
